/* eslint-disable import/no-anonymous-default-export */
import LoadingConstants from './LoadingConsts'


const initialState = {
  visible: false,
  message: 'Loading...',
}

export default (state = initialState, action) => {
  switch (action.type) {
    case LoadingConstants.SET_LOADING:
      return {
        ...state,
        visible: true,
        message: action.payload.message,
      }
    case LoadingConstants.DISABLE_LOADING:
      return {
        ...state,
        visible: false,
        message: '',
      }
    default:
      return state
  }
}

